import { Stack, Typography, useTheme } from "@mui/material";
import { Bell } from "lucide-react";
import { ReminderBadge } from "web_myplann/Reminders/Components/ReminderBadge";
import { ReminderRemoveButton } from "web_myplann/Reminders/Components/ReminderRemoveButton";
import { ReminderRowMeta } from "web_myplann/Reminders/Components/ReminderRowMeta";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	reminder: Reminder;
	onTap: () => void;
	onRemove: () => void;
	id?: string;
	highlighted?: boolean;
};

export const ReminderListRow = ({
	reminder,
	onTap,
	onRemove,
	id,
	highlighted = false,
}: Props) => {
	const theme = useTheme();

	return (
		<Stack
			id={id}
			direction="row"
			alignItems="center"
			gap={1.2}
			onClick={onTap}
			sx={{
				cursor: "pointer",
				position: "relative",
				isolation: "isolate",
				"&::before": {
					content: '""',
					position: "absolute",
					inset: theme.spacing(-0.6, -1),
					zIndex: -1,
					borderRadius: 1,
					bgcolor: highlighted ? theme.palette.purple[100] : "transparent",
					transition: "background-color 300ms ease-out",
					"@media (prefers-reduced-motion: reduce)": {
						transition: "none",
					},
				},
			}}
		>
			<Bell size={20} color={theme.palette.purple.main} />

			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyStrong" color={theme.palette.grey[900]}>
					{reminder.name}
				</Typography>
				<ReminderRowMeta reminder={reminder} withDate />
			</Stack>

			<ReminderBadge reminder={reminder} />

			<ReminderRemoveButton appearance="card" onRemove={onRemove} />
		</Stack>
	);
};
